import { createFileRoute } from '@tanstack/react-router';

export enum LABEL_KEYS {
  VOICE = 'Voice',
  MESSAGE = 'Message',
}

type Search = {
  mode?: LABEL_KEYS;
  comparingLocations?: boolean;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/ai-receptionist')({
  staticData: { team: 'analytics' },
  validateSearch: (search: Search) => {
    return {
      mode: search.mode,
      comparingLocations: search.comparingLocations,
    };
  },
});
